import { BillingStatus } from '@treadinc/horizon-api-spec';

interface ResolveBillingBannerStateArgs {
  billingStatus: BillingStatus | null;
  companyId: string | undefined;
  isImpersonating: boolean;
}

/**
 * Decides which billing banner tier (if any) a user should see. Kept free of
 * React and store dependencies so every rule can be unit-tested in isolation.
 *
 * The banner is an accounts-receivable collections nudge shown to every member
 * of the active company that owes Tread money, but never to Tread staff who are
 * impersonating a customer.
 */
export function resolveBillingBannerState({
  billingStatus,
  companyId,
  isImpersonating,
}: ResolveBillingBannerStateArgs) {
  const bannerIsVisibleToUser = !isImpersonating && Boolean(companyId);

  if (!bannerIsVisibleToUser) {
    return null;
  }

  if (billingStatus === BillingStatus.SUSPENDED) {
    return 'suspended';
  }

  if (billingStatus === BillingStatus.OVERDUE) {
    return 'overdue';
  }

  return null;
}
